import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '..';

const getIsBusy = createSelector(
  (state: RootState) => state.global.isBusy,
  isBusy => isBusy,
);

const getPreferredLanguage = createSelector(
  (state: RootState) => state.global.preferredLanguage,
  preferredLanguage => preferredLanguage,
);

export const GlobalSelector = {
  getIsBusy,
  getPreferredLanguage,
};
